import { normalizeGnssCode } from '../lib/format';
import { sortGnssSystems } from '../lib/gnss_order';

/** Render a horizontal stack of small GNSS-system chips.
 *
 *  The backend stores full system names (``"glonass"``, ``"galileo"``,
 *  ``"beidou"``) but the prototype's CSS keys colours by their 3-letter
 *  short forms (``glo``, ``gal``, ``bds``) — see ``.gnss-chip.gps`` etc.
 *  in ``base.css``. We map via :func:`normalizeGnssCode`.
 *
 *  An empty/missing system list collapses to a single em-dash chip so
 *  the row layout stays stable on jobs created before the column was
 *  populated.
 *
 *  Phase 4.9 — chips render in canonical display order via
 *  :func:`sortGnssSystems`. The API returns arrays alphabetically
 *  (``beidou, galileo, glonass, gps``) but operators read by usage
 *  frequency (``gps, glonass, galileo, beidou``). Single source of
 *  truth keeps every chip surface consistent.
 */
export function GnssStack({ systems }: { systems: string[] }) {
  if (!systems || systems.length === 0) {
    return <span className="gnss-stack">—</span>;
  }
  return (
    <span className="gnss-stack">
      {sortGnssSystems(systems).map((s) => {
        const code = normalizeGnssCode(s);
        return (
          <span key={s} className={`gnss-chip ${code}`}>
            {code}
          </span>
        );
      })}
    </span>
  );
}
